export default "__VITE_PUBLIC_ASSET__b8118b84__"